import PropTypes from 'prop-types';
import React, { FC } from 'react';
import { IIconProps } from 'app/components/svgs/Icon';

interface IGlobeIconProps extends IIconProps {
  color?: string;
}

const Globe: FC<IGlobeIconProps> = ({
  size = '100%',
  width = size,
  height = size,
  color = 'currentColor',
  ...props
}) => (
  <svg width={width} height={height} viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      style={{ fill: color }}
      d="M7.5,0c-1.6,0-3,0.5-4.2,1.3c0,0,0.8,0.8,1.3,0.6c0.5-0.2,0.8-0.2,1.2-0.3h0.6C7,1.6,
         7.8,2,8.1,2.5L8.5,3 C8.8,3.7,9,4.3,8.8,4.8L8.7,5.1c-0.2,0.6-1,1.2-1.2,1.7C7.3,7.3,
         7.6,8.3,7.6,8.9v0.6c0,0.6-0.3,1.2-0.6,1.3 c-0.4,0.1-0.9-0.2-1.3-0.7L5.1,9.3C4.8,8.8,4.4,
         7.9,4.3,7.3l0,0C4.2,6.7,3.8,6,3.3,5.8C2.9,5.6,2.7,4.9,2.8,4.3l0,0 C2.9,3.7,2.7,3,
         2.3,2.7C2.3,2.6,2.1,2.5,2,2.4C0.8,3.7,0,5.5,0,7.5C0,11.6,3.4,15,7.5,15S15,11.6,15,
         7.5C15,3.4,11.6,0,7.5,0z M12.5,11.1l-1.8,1.6c-0.4,0.4-1,0.6-1.3,0.4c-0.3-0.2-0.2-0.7,
         0.1-1.2l0.3-0.4c0.3-0.5,0.8-1.2,1.1-1.6c0.3-0.4,0.8-0.6,1.2-0.6 c0.4,0.1,0.8,0.4,1,
         0.7C13.2,10.1,12.9,10.7,12.5,11.1z"
    />
  </svg>
);

Globe.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
};

export default Globe;
